import React from 'react';
export function ProductsSection() {
  const products = [{
    name: 'Exterior Roller Screens & Retractable Awnings',
    image: 'https://cdn.magicpatterns.com/uploads/v5AJaScQXBjUNC898xLDyV/IMG_1550-1--1920w.webp'
  }, {
    name: 'Interior Roller Shades & Zebra Shades',
    image: 'https://cdn.magicpatterns.com/uploads/ehn8QLDG4qv3PBvue71ax6/IMG_3825-1--1920w.webp'
  }, {
    name: 'Interior Panel Tracks',
    image: 'https://cdn.magicpatterns.com/uploads/7RJZq2DoRV8xL4GmwG5j8W/20230413_183151-1--1920w.webp'
  }, {
    name: 'Interior Cellular Shades',
    image: 'https://cdn.magicpatterns.com/uploads/xvqbHGE5247EugU1zjZcBm/20220108_103005-1--1920w.webp'
  }, {
    name: 'Interior Shutters (Bass Wood & Knotty Alder)',
    image: 'https://cdn.magicpatterns.com/uploads/r3CzULBuVtvUGjPLYZLiDD/20230308_210812-1--1920w.webp'
  }, {
    name: 'Horizontal, Vertical & Aluminum Blinds',
    image: 'https://cdn.magicpatterns.com/uploads/3mCyRga4umcdQbmLmZUfeA/IMG_2389-1--1920w.webp'
  }];
  return <section id="products" className="bg-sand py-16 md:py-28" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-152">
        <div className="text-center mb-10 sm:mb-16" data-id="element-153">
          <span className="block text-gold font-semibold tracking-widest text-sm uppercase mb-4" data-id="element-154">
            Our Products
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-charcoal" data-id="element-155">
            Window Treatments for Every Space
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-156">
          {products.map((product, index) => <div key={index} className="relative overflow-hidden rounded-2xl group cursor-pointer shadow-md bg-white" data-id="element-157">
              <div className="aspect-[4/3] sm:aspect-[3/4] overflow-hidden" data-id="element-158">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-in-out" data-id="element-159" />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent p-6 pt-12" data-id="element-160">
                <h3 className="text-white font-semibold text-xl leading-snug" data-id="element-161">
                  {product.name}
                </h3>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}